import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const tradeSchema = z.object({
  /** Symbol name, e.g. "DOTUSDT" */
  symbol: z.string(),
  /** Side. Buy,Sell */
  side: z.union([z.literal('Buy'), z.literal('Sell')]),
  /** Executed trading fee, e.g. "0.02023296" */
  execFee: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Execution ID, e.g. "2260000000503957098" */
  execId: z.string(),
  /** Execution price, e.g. "4.224" */
  execPrice: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Execution qty, e.g. "4.79" */
  execQty: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  // "execValue": "20.23296",
  /** Executed order value. Classic spot is not supported, e.g. "20.23296" */
  execValue: z.union([
    z.literal('').transform(() => undefined),
    z
      .string()
      .regex(/^\d+(\.\d+)?$/)
      .transform((v) => createBigDecimal(v)),
  ]),
  // "execTime": "1722900417991",
  /** Executed timestamp（ms）, e.g. "1722900417991" */
  execTime: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number.parseInt(v, 10)),
  /** Spot trading fee currency Classic spot is not supported, e.g. "USDT" */
  feeCurrency: z.string(),
  /** Is maker order. true: maker, false: taker */
  isMaker: z.boolean(),
  /** The underlying price of the symbol when executing. Valid for option, e.g. "" */
  underlyingPrice: z.union([
    z.literal('').transform(() => undefined),
    z
      .string()
      .regex(/^\d+(\.\d+)?$/)
      .transform((v) => createBigDecimal(v)),
  ]),
})

export type Trade = z.infer<typeof tradeSchema>

export const resultSchema = z.object({
  nextPageCursor: z.string().nullable().optional(),
  category: z.string(),
  list: z.array(tradeSchema),
})
